<template>
    <div v-show="linkedCustomers.length > 1">
        <multiselect
            v-model="selectedCustomer"
            :options="customerOptions"
            valueProp="id"
            label="name"
            placeholder="Select customer"
            :searchable="true"
            :closeOnSelect="true"
            :canClear="isAdmin"
            :canDeselect="isAdmin"
            class="multi-lg w-full h-7"
            @change="changeActiveCustomer($event)"
            />
    </div>
</template>

<script>
import Multiselect from '@vueform/multiselect'
import '@vueform/multiselect/themes/default.css'
import { usePage } from '@inertiajs/inertia-vue3';
import { useForm } from '@inertiajs/inertia-vue3';
import UseUserAuth from '@/Composables/UseUserAuth';

export default {
    components: {
        Multiselect,
    },

    setup () {
        const { isAdmin, isCustomer } = UseUserAuth(usePage().props.value.user);

        const customerForm = useForm({
            id: usePage().props.value.activeCustomer ? usePage().props.value.activeCustomer.id : null,
        })

        return {
            isAdmin,
            isCustomer,
            customerForm,
        }
    },

    data() {
        return {
            linkedCustomers: [],
            selectedCustomer: this.$page.props.activeCustomer
                ? this.$page.props.activeCustomer.id
                : null,
        }
    },

    methods: {
        changeActiveCustomer(id) {

            if (this.isAdmin || !this.activeCustomer || this.activeCustomer.id !== id)
            {
               this.customerForm.id = id;

                if(!this.customerForm.processing) {
                    this.customerForm.submit('post', route('activecustomer.set.active'));
                }
            }

        },


        fetchLinkedCustomers() {

            axios.get(route('activecustomer.get.linked'))
            .then(response => {
                if(response.data.length) {
                    this.linkedCustomers = response.data;
                }

            })
            .catch(error => {
                console.log(error);
            });

        }
    },

    computed: {

        customerOptions() {
            if(this.linkedCustomers.length)
            {
                return this.linkedCustomers.map(i => {
                    return {
                        name: i.name,
                        id: i.id
                    }
                });
            }
        },

        activeCustomer() {
            return this.$page.props.activeCustomer;
        }

    },

    mounted () {
        this.fetchLinkedCustomers();
    }
}



</script>